/**
 * 示意图数据
 */
import { IMAGE_TYPE, INPUT_IMAGE_TYPE, CLOTH_COLOR_TYPE } from "./CONST";

const imageBaseUrlV3 = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/diagrams/";

export default {
    [IMAGE_TYPE.MODEL]: {
        input: [{
            urls: [
                imageBaseUrlV3 + "model_a.png",
            ],
            name: "上传模特图"
        }, {
            urls: [
                imageBaseUrlV3 + "模特和场景.png",
            ],
            name: "选择模特/背景"
        }],
        output: {
            url: imageBaseUrlV3 + "model_d.png",
            name: "生成效果图"
        }
    },
    [IMAGE_TYPE.POSE_TRYON]: {
        input: [{
            urls: [
                imageBaseUrlV3 + "model_poseTryon.png",
            ],
            name: "上传模特图"
        }, {
            urls: [
                imageBaseUrlV3 + "reference_poseTryon.png",
            ],
            name: "选择参考图"
        }],
        output: {
            url: imageBaseUrlV3 + "result_poseTryon.png",
            name: "生成效果图"
        }
    },
    [IMAGE_TYPE.GLASSES_TRYON]: {
        input: [{
            urls: [
                imageBaseUrlV3 + "model_glasses.png",
            ],
            name: "上传眼镜图"
        }, {
            urls: [
                imageBaseUrlV3 + "reference_glasses.png",
            ],
            name: "选择参考图"
        }],
        output: {
            url: imageBaseUrlV3 + "result_glasses.png",
            name: "生成效果图"
        }
    },
    [IMAGE_TYPE.SIM_TRYON]: {
        input: [{
            urls: [
                imageBaseUrlV3 + "model_simTryon.png",
            ],
            name: "上传衣服图"
        }, {
            urls: [
                imageBaseUrlV3 + "reference_simTryon.png",
            ],
            name: "选择参考图"
        }],
        output: {
            url: imageBaseUrlV3 + "result_simTryon.png",
            name: "生成效果图"
        }
    },
    [IMAGE_TYPE.CLOTHES]: {
        [INPUT_IMAGE_TYPE.SINGLE]: {
            input: [{
                urls: [
                    imageBaseUrlV3 + "tryon_single_a.png"
                ],
                name: "上传衣服图"
            }, {
                urls: [
                    imageBaseUrlV3 + "tryon_single_b.png"
                ],
                name: "选择参考图"
            }],
            output: {
                url: imageBaseUrlV3 + "tryon_single_c.png",
                name: "生成效果图"
            }
        },
        [INPUT_IMAGE_TYPE.MULTI]: {
            input: [{
                urls: [
                    imageBaseUrlV3 + "服装-搭配.png",
                ],
                name: "上传上装和下装"
            }, {
                urls: [
                    imageBaseUrlV3 + "tryon_set_c.png"
                ],
                name: "选择参考图"
            }],
            output: {
                url: imageBaseUrlV3 + "tryon_set_d.png",
                name: "生成效果图"
            }
        }
    },
    [IMAGE_TYPE.SHOES]: {
        [INPUT_IMAGE_TYPE.SINGLE]: {
            input: [{
                urls: [
                    imageBaseUrlV3 + "shoe_single_a.png",
                ],
                name: "上传鞋子图"
            }, {
                urls: [
                    imageBaseUrlV3 + "shoe_single_b.png",
                ],
                name: "选择参考图"
            }],
            output: {
                url: imageBaseUrlV3 + "shoe_single_c.png",
                name: "生成效果图"
            }
        },
        [INPUT_IMAGE_TYPE.MULTI]: {
            input: [{
                urls: [
                    imageBaseUrlV3 + "鞋子上脚-多视角.png",
                ],
                name: "上传多视角鞋子图"
            }, {
                urls: [
                    imageBaseUrlV3 + "shoe_set_c.png",
                ],
                name: "选择参考图"
            }],
            output: {
                url: imageBaseUrlV3 + "shoe_set_d.png",
                name: "生成效果图"
            }

        }
    },
    [IMAGE_TYPE.COMMODITY]: {
        input: [{
            urls: [
                imageBaseUrlV3 + "object_a.png",
            ],
            name: "上传商品图"
        }, {
            urls: [
                imageBaseUrlV3 + "object_b.png",
            ],
            name: "选择背景"
        }],
        output: {
            url: imageBaseUrlV3 + "object_c.png",
            name: "生成效果图"
        }
    },
    [IMAGE_TYPE.COMMODITYRECOLOR]: {
        input: [{
            urls: [
                imageBaseUrlV3 + "color_aa.png",
            ],
            name: "上传商品图"
        }, {
            urls: [
                imageBaseUrlV3 + "颜色.png",
            ],
            name: "选择颜色"
        }],
        output: {
            url: imageBaseUrlV3 + "color_cc.png",
            name: "生成效果图"
        }
    },
    [IMAGE_TYPE.CLOTH_RECOLOR]: {
        input: [{
            urls: [
                imageBaseUrlV3 + "color_a.png",
            ],
            name: "上传模特图或服饰图"
        }, {
            urls: [
                imageBaseUrlV3 + "颜色.png",
            ],
            name: "选择颜色"
        }],
        output: {
            url: imageBaseUrlV3 + "color_c.png",
            name: "生成换色效果图 "
        }
    },
    [CLOTH_COLOR_TYPE.SIM_RECOLOR]: {
        input: [{
            urls: [
                imageBaseUrlV3 + "simRecolor1.png",
            ],
            name: "上传模特图"
        }, {
            urls: [
                imageBaseUrlV3 + "simRecolor2.png",
            ],
            name: "上传同款参考图"
        }],
        output: {
            url: imageBaseUrlV3 + "simRecolor3.png",
            name: "生成换色效果图"
        }
    },
    [IMAGE_TYPE.MODEL_VIDEO]: {
        input: [{
            urls: [
                imageBaseUrlV3 + "viedo_a.png",
            ],
            name: "上传模特图"
        }, {
            urls: [
                imageBaseUrlV3 + "viedo_b.png",
            ],
            name: "选择动作"
        }],
        output: {
            url: imageBaseUrlV3 + "viedo_c.mp4",
            video: true,
            name: "生成效果视频"
        }
    },
    [IMAGE_TYPE.IMAGE_TO_VIDEO]: {
        input: [{
            urls: [
                imageBaseUrlV3 + "viedo_a.png",
            ],
            name: "上传模特图"
        }, {
            urls: [
                imageBaseUrlV3 + "viedo_b.png",
            ],
            name: "选择动作"
        }],
        output: {
            url: imageBaseUrlV3 + "viedo_c.png",
            name: "生成效果图"
        }
    },
}
